
<!-- `#tableContainer`: the paginator footer below is `position: fixed` (viewport-relative), so it
     is sized to THIS box at runtime -- see `syncFooterToContent` in the component. -->
<div class="table-container" #tableContainer *ngIf=" tableData && config?.columnsFields">
    <!-- sort remove -->

    <!-- A table whose rows are a roving tabindex says so in its NAME, which a screen reader reads once
         on entering the table: nothing else tells a non-sighted user the arrows move between rows and
         Enter activates one. -->
    <mat-table class="tableSummary mat-elevation-z2" #table [dataSource]="renderedRows"
        [attr.aria-label]="rowNavigationHintKey ? (rowNavigationHintKey | translate) : null">
        <!--- Note that these columns can be defined in any order.
      The actual rendered columns are set as a property on the row definition" -->

        <ng-container *ngIf="isSelectionMultiple()">
            <ng-container [cdkColumnDef]="'multi_selection'">
                <mat-header-cell class="table-header" *cdkHeaderCellDef>
                    <div class="select-field-selectable in_header">
                        <!-- {{'common.table.pageSelection' | translate}} -->

                        <mat-checkbox [aria-label]="'common.aria.selectAllRows' | translate"
                            [disabled]="tableData.data.length == 0 || disableForSession()"
                            [(ngModel)]="selectAll"></mat-checkbox>
                    </div>
                </mat-header-cell>
                <mat-cell *cdkCellDef="let row">
                    <div class="select-field-selectable in_row" (click)=" $event.stopPropagation(); ">

                        <mat-checkbox name="single_select" [aria-label]="'common.aria.selectRow' | translate"
                            [ngClass]="{'disabl__checkbox': !isEnabled('select_row', row) }"
                            [disabled]="!isEnabled('select_row', row)"
                            (click)=" onSelectCheck({row, not: true}); $event.stopPropagation(); "
                            [checked]="isSelected(row)"></mat-checkbox>
                    </div>
                </mat-cell>
                <mat-footer-cell *cdkFooterCellDef class="summary-cell"></mat-footer-cell>
            </ng-container>
        </ng-container>

        <!-- Var columns -->
        <ng-container *ngFor="let columnField of config?.columnsFields">
            <ng-container [cdkColumnDef]="columnField.id">
                <mat-header-cell class="table-header" *cdkHeaderCellDef>
                    <div style="display: flex;flex-direction: column;">
                        <div style="display: flex; flex-direction: row; width: 100%;"
                            [ngClass]="{'pointerMouse' : columnField?.sortable}">

                            <app-sort-header class="d-flex header-table-text" [direction]="sortDirection(columnField)"
                                [sortable]="!!columnField?.sortable"
                                [rank]="sortRank(columnField)" [rankDirection]="sortRankDirection(columnField)"
                                (sort)="setSort(columnField)">
                                <span class="select-field" [ngClass]="{'pointerMouse' : columnField?.sortable}">
                                    {{columnField.label | translate}}
                                </span>

                                <span class="sort-indicator" aria-hidden="true" style="cursor:pointer" matBadgeSize="small" *ngIf="sortStatus[columnField.id]"
                                    matBadgePosition="before" [matBadge]="sortStatus[columnField.id].position + 1">
                                    <mat-icon>
                                        {{ sortStatus[columnField.id].direction == 'ASC' ? 'arrow_drop_up' :
                                        'arrow_drop_down' }}
                                    </mat-icon>
                                </span>
                            </app-sort-header>

                        </div>
                        <ng-container *ngIf="columnField.editable">
                            <ng-container *ngIf="columnField.typeField; else noTypeField">
                                <div class="input-group input-group-sm default_item__">
                                    <div class="input__">
                                        <input [disabled]="setAvailable" [min]="0"
                                            name="{{columnField}}_{{columnField.id}}"
                                            [(ngModel)]="bindingType(columnField.id).typeIdInput"
                                            [type]="columnField.typeField" class="form-control item__"
                                            [attr.aria-label]="'common.aria.small' | translate" aria-describedby="inputGroup-sizing-sm">
                                    </div>
                                    <div class="all_available">
                                        <button type="button" [attr.aria-label]="'common.aria.useAvailableQuantity' | translate"
                                            [attr.aria-pressed]="setAvailable"
                                            [matTooltip]="'common.aria.useAvailableQuantity' | translate" disableRipple="{{true}}" class="btn__"
                                            (click)="setQuantity($event)" mat-icon-button>
                                            <mat-icon [color]="setAvailable == true ? 'primary' : null"
                                                class="icon__">{{ setAvailable ? 'swipe_down' : 'swipe_up'}}</mat-icon>
                                        </button>

                                    </div>
                                </div>
                            </ng-container>
                            <ng-template #noTypeField>
                                <div class="input-group input-group-sm default_item__cust">
                                    <div class="c_1">
                                        <input type="number" [min]="0" [(ngModel)]="bindingType(columnField.id).typeId"
                                            class="form-control item__">
                                    </div>
                                    <div class="c_2">
                                        <select #typeSelect="ngModel" class="form-select form-select-sm item__"
                                            style="background-position: center !important;"
                                            [(ngModel)]="bindingType(columnField.id).typeId" [name]="columnField.id">
                                            <option [ngValue]="null"></option>
                                            <!-- fixme santiago cablato il whHost -->
                                            <option *ngFor="let item of whHost[whHost.length - 1]?.warehouses"
                                                [ngValue]="item">
                                                {{item?.id}} - {{item?.name}}
                                            </option>

                                        </select>
                                    </div>
                                </div>
                            </ng-template>

                        </ng-container>
                    </div>
                </mat-header-cell>

                <mat-cell *cdkCellDef="let row"
                    [ngClass]="{'success': isPendingDelete(row), 'danger': (!statusPer || statusPer == undefined || statusPer == null)}">

                    <!-- g15-pointer-only: the mobile stacked-card pseudo-header, rendered once per CELL per ROW
                         (~800 on a 100x8 list). Making it a button would put 800 tab stops between the filter and the
                         first row -- the per-data-point case the throughput chart's roving tabindex exists to avoid.
                         The sort FUNCTION is keyboard-reachable through the header strip this breakpoint now shows, so
                         WCAG 2.1.1 is satisfied; this tap is a redundant pointer shortcut, and removing a gesture
                         mobile users may rely on would be a regression for no accessibility gain. -->
                    <div class="_isNewHeader non_show" [ngClass]="{'pointerMouse' : columnField?.sortable}"
                        (click)="setSort(columnField); $event.stopPropagation(); ">
                        <span class="mobile-label">{{columnField.label | translate}}</span>

                        <span style="cursor:pointer" matBadgeSize="small" *ngIf="sortStatus[columnField.id]"
                            matBadgePosition="before" [matBadge]="sortStatus[columnField.id].position + 1">
                            <mat-icon>

                                {{sortStatus[columnField.id].direction == 'ASC' ? 'arrow_drop_up' :
                                'arrow_drop_down'}}

                            </mat-icon>
                        </span>

                    </div>
                    <!-- Why a highlighted child stands out, for a screen reader: the highlight itself is a colour
                         and a rail, both visual. Once per row, in the first value cell. Outside the cell anchor,
                         so it does not become part of a link's name. -->
                    <span class="visually-hidden" *ngIf="row.__highlight && columnField.id === firstValueColumnId && config?.groupRow?.highlightLabelKey as labelKey">{{ labelKey | translate }}</span>
                    <!-- A group row's open/closed state, for a screen reader. Text, not `aria-expanded` on the row:
                         ARIA honours that on a row only in a treegrid, and this is a table. Once per row, in the
                         first value cell, outside the cell anchor. -->
                    <span class="visually-hidden" *ngIf="columnField.id === firstValueColumnId && groupStateKey(row) as stateKey">{{ stateKey | translate }}</span>
                    <!-- cell-link navigable cell; markup mirrored in CELL_TEMPLATE in table.component.spec.ts -->
                    <!-- appCellCopy hosts on the .cell-copy-host wrapper, NOT <app-column>: ColumnComponent renders its
                         column view as a *sibling* of <app-column> (empty host), so the wrapper is what actually contains
                         the value's text and receives its contextmenu. The wrapper is display:contents (no layout box). -->
                    <ng-container *ngIf="resolveLink(columnField, row) as cellLink; else plainCell">
                      <!-- g15-unnamed-control: the anchor's name is the cell's own value, rendered by
                           <app-column>; an aria-label here would replace that value, not add to it -->
                      <a [routerLink]="cellLink" class="cell-link" (click)="$event.stopPropagation()">
                        <span class="cell-copy-host" appCellCopy>
                          <app-column style="width: auto;" [instanceCustom]="" [field]="columnField" [row]="row"></app-column>
                        </span>
                      </a>
                    </ng-container>
                    <ng-template #plainCell>
                      <span class="cell-copy-host" appCellCopy>
                        <app-column style="width: auto;" [instanceCustom]="" [field]="columnField" [row]="row"></app-column>
                      </span>
                    </ng-template>
                </mat-cell>
                <mat-footer-cell *cdkFooterCellDef class="summary-cell">{{ summaryCell(columnField.id) }}</mat-footer-cell>
            </ng-container>
        </ng-container>

        <ng-template #defaultGetActions>
            <ng-container *ngIf="tableData && tableData.tableStatus && tableData.tableStatus.sort  ">

                <!-- Gated on clearableSortCount, NOT on the echoed tableStatus.sort: a sort field
                     with no column of its own cannot be cleared by this button, so counting it
                     advertises a control that does nothing. See clearableSortCount. -->
                <button type="button" [attr.aria-label]="'common.clearSort' | translate" *ngIf="clearableSortCount > 0" matBadgeSize="small"
                    matBadge="{{clearableSortCount}}" [matTooltip]="'common.clearSort' | translate"
                    mat-icon-button color="warn" (click)="clearSort(); $event.preventDefault();">
                    <mat-icon>sort</mat-icon>
                </button>

            </ng-container>
        </ng-template>

        <ng-container [cdkColumnDef]="'actions'"
            *ngIf="getActions('RECORD') && getActions('RECORD').length > 0; else defaultGetActions">
            <mat-header-cell class="table-header" *cdkHeaderCellDef>

                <ng-container *ngIf="featureCode === 'buylistTemplate'">
                    <button type="button" [attr.aria-label]="'prices.buyTemplate.toggleEditMode' | translate"
                        [attr.aria-pressed]="modeIcon"
                        [matTooltip]="'prices.buyTemplate.toggleEditMode' | translate"
                        (click)="modifyModeIcon()" mat-icon-button>
                        <mat-icon>switch_access_shortcut</mat-icon>
                    </button>
                </ng-container>

                <ng-container *ngIf="getActions('GLOBAL') && getActions('GLOBAL').length > 0; else action_descr ">
                    <ng-container
                        *ngTemplateOutlet="!mediumScreenAndDown ? defaultActions : dropdownActions; context: { item: null, type: 'GLOBAL'}"></ng-container>
                </ng-container>
                <ng-template #action_descr>{{'common.table.actions' | translate}} </ng-template>

            </mat-header-cell>
            <mat-cell *cdkCellDef="let row">
                <ng-container
                    *ngTemplateOutlet="!mediumScreenAndDown ? defaultActions : dropdownActions; context: { item: row, type: 'RECORD'}"></ng-container>
            </mat-cell>
            <mat-footer-cell *cdkFooterCellDef class="summary-cell"></mat-footer-cell>
        </ng-container>

        <mat-header-row *cdkHeaderRowDef="displayedColumns;  sticky: true" class="st_header"
            [class.has-sortable-column]="hasSortableColumn">


        </mat-header-row>
        <!-- One row def for BOTH kinds. A group's children are spliced into `renderedRows` and go
             through this same def, so a child carries the list's own columns and cell components and
             is aligned to the column grid by construction -- that is the whole point of splicing
             rather than rendering a nested list inside one full-width cell. `group-child` is the
             only difference, and it only indents. -->
        <!-- A row whose click does something is reachable by keyboard through a roving tabindex: the
             table is one tab stop, the arrows move between rows, Enter/Space click. See
             `TableComponent.onRowKeydown`. -->
        <mat-row [ngClass]="{'selected':isSelected(row), 'selectable':selectMode}"
            [class.group-child]="isGroupChild(row)"
            [class.row-band-alt]="row.__band === 1"
            [class.row-banded]="config?.groupRow"
            [class.group-open]="row.__groupBlockStart"
            [class.group-block-end]="row.__groupBlockEnd"
            [class.group-child-match]="row.__highlight"
            [attr.tabindex]="rowTabindex(row)"
            (focus)="onRowFocus(row)"
            (keydown)="onRowKeydown(row, $event)"
            (click)="onRowClick(row, $event, onlycheck); $event.preventDefault(); "
            *cdkRowDef="let row; columns: displayedColumns;"></mat-row>

        <!-- Gate the footer row def on the *config* (stable from first render), not on the async
             totals: CdkTable registers header/footer row defs at content-init and does not reliably
             pick up a def added later. While the totals load, the row is hidden via CSS. -->
        <ng-container *ngIf="config?.summaryRow">
            <mat-footer-row *cdkFooterRowDef="displayedColumns; sticky: true" class="summary-row"
                [class.summary-row--span]="!!config?.summaryRow?.spanLeadingCell"
                [class.summary-row--hidden]="!showSummaryRow"></mat-footer-row>
        </ng-container>

    </mat-table>

    <ng-container *ngIf="config?.paginatorMode == 'none'; else default_pagination">
        <mat-paginator style="display: none" [pageSize]="tableData.tableStatus.page.pageSize"
            [pageIndex]="tableData.tableStatus.page.pageIndex" [pageSizeOptions]="[20,50,100]"
            [showFirstLastButtons]="true" [length]="tableData.tableStatus.page.length">
        </mat-paginator>
    </ng-container>

</div>



<ng-template #default_pagination>

    <!-- NOT `.sticky-bottom`: WebKit does not repaint a STUCK sticky layer when its content
         changes, so on Safari this paginator kept showing a stale total. `.cust_` pins it with
         `position: fixed` instead — read the comment on that rule before changing this. -->
    <div class="cust_">

        <mat-paginator class="mat-elevation-z2" [pageSize]="tableData.tableStatus.page.pageSize"
            [pageIndex]="tableData.tableStatus.page.pageIndex" [pageSizeOptions]="[20,50,100]"
            [showFirstLastButtons]="true" [length]="tableData.tableStatus.page.length">
        </mat-paginator>
        <ng-container *ngIf=" !notInputPage ">


            <mat-form-field class="custm_">
                <mat-label>{{ 'common.table.toPage' | translate }}</mat-label>
                <input [disabled]="(tableData.tableStatus.page.length == 0) || !tableData.tableStatus.page.length"
                    #inputSingle_ matInput name="input_single" [min]="1" type="number" (keyup.enter)="goToPage($event)"
                    [(ngModel)]="pageIndex">
            </mat-form-field>

        </ng-container>
    </div>


</ng-template>

<ng-template #dropdownActions let-item="item" let-type="type" let-tableComponent="tableComponent">
    <button type="button" [attr.aria-label]="'common.aria.rowActions' | translate"
        [matTooltip]="'common.aria.rowActions' | translate"
        (click)="$event.stopPropagation()" mat-icon-button [matMenuTriggerFor]="menu">
        <mat-icon>menu</mat-icon>
    </button>
    <mat-menu #menu="matMenu">
        <ng-container *ngFor="let ac of getActions(type)">
            <ng-container *ngIf="ac.event && isEnabled(ac.event, item)">
                <ng-container *ngIf="ac.actionComponent">

                    <!-- fixme santiago nuevo dato per app action -->
                    <app-action [instanceCustom]="" [action]="ac" [item]="item"
                        (event)="customEvent($event.name, $event.data)"></app-action>
                </ng-container>
                <ng-container *ngIf="!ac.actionComponent">
                    <button type="button" mat-icon-button *ngIf="isEnabled(ac.event, item)"
                        [matTooltip]="(ac.label || ac.event) | translate"
                        [attr.aria-label]="ac.icon ? ((ac.label || 'common.aria.rowActions') | translate) : null"
                        (click)="customEvent(ac.event, item);$event.stopPropagation()">
                        <mat-icon *ngIf="ac.icon; else label">{{ac.icon}}</mat-icon>
                        <ng-template #label>{{ac.label || '' | translate}}</ng-template>
                    </button>
                </ng-container>
            </ng-container>

        </ng-container>
    </mat-menu>
</ng-template>

<ng-template #defaultActions let-item="item" let-type="type" let-instanceValue="instanceValue"
    let-tableComponent="tableComponent">



    <ng-container *ngFor="let ac of getActions(type)">
        <ng-container *ngIf="ac.event && isEnabled(ac.event, item)">
            <ng-container *ngIf="ac.actionComponent">
                <!-- fixme santiago nuevo dato per app action -->
                <app-action [instanceCustom]="instanceValue" [action]="ac" [item]="item"
                    (event)="customEvent($event.name, $event.data)"></app-action>
            </ng-container>
            <ng-container *ngIf="!ac.actionComponent">
                <button type="button" mat-icon-button="" [matTooltip]="(ac.label || ac.event ) | translate"
                    [attr.aria-label]="ac.icon ? ((ac.label || 'common.aria.rowActions') | translate) : null"
                    (click)="$event.stopPropagation();customEvent(ac.event, item);">
                    <mat-icon *ngIf="ac.icon; else label">{{ac.icon}}</mat-icon>
                    <ng-template #label>{{ac.label || '' | translate}}</ng-template>
                </button>
            </ng-container>
        </ng-container>
    </ng-container>
</ng-template>